//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {parser} from "@/utils/parser";

export default {
  name: "GuidesGrid",
  components: {
    GuideCard: () => import("@/components/common/GuideCard"),
    Button: () => import("@/components/common/Button"),
    Section: () => import("@/components/common/Section")
  },
  props: {
    params: {
      type: Object,
      default: () => ({
        cityId: null,
        count: 8,
        page: 1,
      })
    }
  },
  data() {
    return {
      cityId: null,
      pending: false,
      guides: [],
      meta: null,
      count: 8,
      page: 1,
    }
  },
  computed: {
    show() {
      return this?.meta?.last_page !== this?.meta?.current_page || false
    },
  },
  created() {
    Object.assign(this.$data, this.params)
  },
  mounted() {
    this.request()
  },
  methods: {
    request() {
      const params = {
        ...this.params,
        page: this.page,
        count: this.count,
        lang: this.$i18n.locale,
        resolution: 'micro',
        type: 'travel'
      }
      this.pending = true
      this.$axios.$get(`/api/guides?${parser({params})}`)
        .then(response => {
          this.guides = [...this.guides, ...response.data]
          this.meta = response.meta
        })
        .catch(() => {
          this.guides = []
          this.meta = null
        })
        .finally(() => {
          this.pending = false
        })
    },
    click() {
      this.page += 1
      this.request()
    }
  }
}
